// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer-bottom-text__title{margin-bottom:20px;font-size:14px;font-weight:600;line-height:18px}@media only screen and (min-width:992px){.footer-bottom-text__title{margin-bottom:5px}}.footer-bottom-text__subtitle{margin-bottom:40px;font-size:12px;line-height:18px}@media only screen and (min-width:992px){.footer-bottom-text__subtitle{margin-bottom:0}}", ""]);
// Exports
module.exports = exports;
